import React from "react";
import { add, differenceInDays, format } from "date-fns";

export const formatDate = (date, dateFormat) => {
  return format(date, dateFormat);
};

export const addDuration = (date, duration) => {
  return add(date, duration);
};

export const dateDifference = (dateLeft, dateRight) => {
  return differenceInDays(dateLeft, dateRight);
};
